import { observer } from "mobx-react-lite";
import { useState } from "react";
import { appState } from "@/app/appState";
import { chatState } from "@/app/chatState";
import { formatHistoryTime } from "@/components/richtext/Citation/CitationNode";
import { TextMessageDisplay } from "../chatMessage";
import { openHistoryViewer } from "./historyViewer";

const isoToEpoch = (iso: string) => Math.floor(new Date(iso).getTime() / 1000);

/** Memory headlines for the compressed part of the conversation, oldest first. */
export const EarlierInConversation = observer(() => {
    const [open, setOpen] = useState(false);
    const { memories, historySpan, conversationId } = chatState;
    if (conversationId === null || (memories.length === 0 && !historySpan)) return null;

    return (
        <div className="chat-turn w-full">
            <button type="button" className="text-sm opacity-70 hover:opacity-100 w-full text-left px-2 py-1" onClick={() => setOpen(!open)}>
                {open ? "▾ " : "▸ "}
                {appState.t("chat.earlier.title")}
                {historySpan && ` · ${formatHistoryTime(isoToEpoch(historySpan.start_time))} – ${formatHistoryTime(isoToEpoch(historySpan.end_time))}`}
            </button>
            {open && (
                <div className="flex flex-col gap-2 px-2 pb-2">
                    {memories.map((memory) => (
                        <div key={memory.memory_id} className="text-sm">
                            <div className="text-xs opacity-60">
                                {memory.kind === "legacy" || !memory.start_time || !memory.end_time
                                    ? appState.t("chat.earlier.legacy")
                                    : `${formatHistoryTime(isoToEpoch(memory.start_time))} – ${formatHistoryTime(isoToEpoch(memory.end_time))}`}
                            </div>
                            <TextMessageDisplay contentClass="" content={memory.headline} />
                        </div>
                    ))}
                    {historySpan && (
                        <button
                            type="button"
                            className="text-sm underline opacity-70 hover:opacity-100 self-start"
                            onClick={() => openHistoryViewer({ conversationId })}
                        >
                            {appState.t("chat.earlier.viewHistory")}
                        </button>
                    )}
                </div>
            )}
        </div>
    );
});
